import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import WoocommerceAPI from '../../IPSAPI/WoocommerceAPI';
import ContentElStepper from './ContentElStepper.tsx';
import ItemInfo from './ItemInfo';
import SkeletonContent from '../../Skeleton/SkeletonContent';
import SC_ManageData from '../SC_ManageData';
import { RootState } from '../../../redux/checkoutredux/store/checkoutStore';

interface ContentElementProps {
  loading: boolean;
  currentProductId: string[];
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>;
  currentCartKeyId: string[];
  setCurrentCartKeyId: React.Dispatch<React.SetStateAction<string[]>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const ContentElement: React.FC<ContentElementProps> = ({
  loading,
  currentProductId,
  setCurrentProductId,
  currentCartKeyId,
  setCurrentCartKeyId,
  setLoading,
}) => {
  const store = useSelector((state: RootState) => state);
  const settings = useSelector((state: RootState) => state.sidecartsettings.appSettings || null);
  const cartItems = useSelector((state: RootState) => state.shoppingcart.productdata || []);
  const [isConditionMet, setIsConditionMet] = useState<boolean>(true);
  const [productStatus, setProductStatus] = useState<Record<string, string>>({});

  const deleteAndFetchData = async (keyId: string) => {
    try {
      setLoading(true);
      const response = await WoocommerceAPI.ajax_removeFromCart(settings.base_url, keyId);
      SC_ManageData.fetchDataDirect(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching products:', error);
    }
  };

  const checkSomeCart = (): boolean => {
    if (cartItems && cartItems.length > 0 && currentProductId.length > 0 && loading) {
      return cartItems.some(
        (product) =>
          parseInt(currentProductId[0]) === parseInt(product.id) &&
          (currentCartKeyId.length !== 0 ? currentCartKeyId[0] === product.key : true)
      );
    }
    return false;
  };

  const handleRemoveFromCart = async (productKey: string, productId: string) => {
    try {
      setCurrentProductId([productId]);
      setCurrentCartKeyId([productKey]);
      setProductStatus({ ...productStatus, [productId]: 'deleting' });

      setLoading(true);
      const response = await WoocommerceAPI.ajax_removeFromCart(settings.base_url, productKey);

      const updatedProductStatus = { ...productStatus };
      delete updatedProductStatus[productId];
      setProductStatus(updatedProductStatus);

      setLoading(false);
      SC_ManageData.fetchDataDirect(response);
      setCurrentCartKeyId([]);
    } catch (error) {
      console.error('Error removing product from cart:', error);
    }
  };

  useEffect(() => {
    const allDeleted = Object.keys(productStatus).length === 0 && productStatus.constructor === Object;
    if (allDeleted) {
      setLoading(false);
    }
  }, [productStatus, setLoading]);

  useEffect(() => {
    if (cartItems && cartItems.length > 0 && currentProductId.length > 0 && loading) {
      const conditionMet = cartItems.some(
        (product) => parseInt(currentProductId[0]) === parseInt(product.id)
      );
      setIsConditionMet(conditionMet);
    } else {
      setIsConditionMet(false);
    }
  }, [cartItems, currentProductId, loading]);

  return (
    <div className="content-element">
      {cartItems.map((product) => (
        <div className="row py-2 ips-item-row ips-innercontent-row" key={product.id}>
          {parseInt(currentProductId[0]) === parseInt(product.id) &&
          currentCartKeyId &&
          product.key &&
          (currentCartKeyId.length !== 0 ? currentCartKeyId[0] === product.key : true) &&
          loading ? (
            <div>
              <SkeletonContent />
            </div>
          ) : (
            <>
              <div className="d-flex justify-content align-items-center col-2 mt-1 mb-1 my-auto ips_orderimgmobile">
                <div className="ips-cartitem-image">
                  <a href={product.productlink}>
                    <div
                      className={`${
                        product.producttyp === 'ticket-event' ? 'ips-image-cartproduct' : ''
                      }`}
                      dangerouslySetInnerHTML={{ __html: product.product_image }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-8 mt-1">
                <div className="d-flex flex-row ips-cartitem-title">
                  <a href={product.productlink}>{product.name}</a>
                </div>
                {product.morecartinfo && product.morecartinfo.trim() !== '' && (
                  <div
                    className="d-flex flex-row"
                    dangerouslySetInnerHTML={{ __html: product.morecartinfo }}
                  ></div>
                )}
                {product.producttyp !== 'ticket-event' && (
                  <div className="d-flex flex-row">
                    <div className="col-6 mt-1">
                      <ContentElStepper
                        productId={product.id}
                        keyId={product.key}
                        quantity={product.quantity}
                        deleteandfetchData={deleteAndFetchData}
                        setCurrentProductId={setCurrentProductId}
                        currentCartKeyId={currentCartKeyId}
                        setCurrentCartKeyId={setCurrentCartKeyId}
                        setLoading={setLoading}
                        orderbumpupdate={product.orderbumpupdate}
                      />
                    </div>
                    <div className="col-6 mt-1 d-flex align-items-center justify-content-end">
                      <ItemInfo filterdata={product.filterbeforecartitem} />
                    </div>
                  </div>
                )}
              </div>
              <input
                type="hidden"
                className="ips_wooadd_cat"
                data-cat={product.allcategories}
                data-catids={product.allcategorieids}
                data-ptyp={product.producttyp}
                name="ips_woo_cat"
              ></input>
              <div className="justify-content align-items-center px-0 col-2 mt-1 mb-1 my-auto">
                <div className="d-flex justify-content-end ips-remove-btnselect flex-row">
                  <div
                    className="ips-sidecart-remove-btn"
                    onClick={() => handleRemoveFromCart(product.key, product.id)}
                  >
                    X
                  </div>
                </div>
                <div
                  className="d-flex justify-content-end ips-flex-row flex-row ips-content-priceelement"
                  dangerouslySetInnerHTML={{ __html: product.priceinctaxformat }}
                ></div>
              </div>
            </>
          )}
        </div>
      ))}
      {!checkSomeCart() && loading && (
        <div>
          <SkeletonContent />
        </div>
      )}
    </div>
  );
};

export default ContentElement;